import React from "react";
import CrudManager from "@/components/admin/CrudManager";

export default function Sliders() {
  return (
    <CrudManager
      title="Homepage Sliders"
      description="Manage the rotating banners on your homepage hero."
      endpoint="sliders"
      fields={[
        { name: "title", label: "Title", type: "text", placeholder: "Slider heading" },
        { name: "subtitle", label: "Subtitle", type: "textarea" },
        { name: "image", label: "Background Image", type: "image" },
        { name: "cta_text", label: "Button Text", type: "text", placeholder: "Explore Products" },
        { name: "cta_link", label: "Button Link", type: "text", placeholder: "/products" },
        { name: "order", label: "Display Order", type: "number" },
        { name: "active", label: "Visible", type: "switch" },
      ]}
      columns={[
        { name: "image", label: "Image", type: "image" },
        { name: "title", label: "Title", type: "text" },
        { name: "order", label: "Order", type: "number" },
        { name: "active", label: "Status", type: "switch" },
      ]}
    />
  );
}
